import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { SelectFromConstant } from '../../../components/dropdown-select/SelectFromConstant';
import { servicePriorities } from '../../../config/constants/servicePrioritiesConstants';

export const SelectPriority = ({ value, onChange }) => {
  const { translate: t } = useDictionaryTranslation();
  const options = useMemo(() => {
    return Object.values(servicePriorities).map((option) => ({
      ...option,
      label: t(option.label, { n: option.time }),
    }));
  }, [t]);

  const selectedValue = value && options.find((v) => v.value === value.value);

  return (
    <SelectFromConstant
      value={selectedValue}
      onChange={onChange}
      constantObject={options}
      placeholderText={t('priorityPlaceholder')}
    />
  );  
};

SelectPriority.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
};
